import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { PdfActionCreators } from 'app/reducers/PdfDownloadRedux'
import { Spinner } from 'controls/'
import styles from './styles'
const INITIAL_STATE = {
  property: {},
  endPoint: '',
  isFetching: false,
  extraInfo: {}
}
import { PROPERTY_TYPE_LABELS, OPERATION_TYPE_LABELS } from 'app/services/seo'

const Brochure = props => {
  const { property, withBrokerInfo, withFullAddress, type } = props
  const [state, setState] = useState({
    ...INITIAL_STATE,
    property,
    extraInfo: {
      withBrokerInfo,
      withFullAddress
    }
  })
  const dispatch = useDispatch()

  const {
    pdfDownload: { error, loading, messageError, request, success }
  } = useSelector(state => ({
    pdfDownload: state.pdfDownload
  }))

  function getEndPoint(type, property) {
    const typesPdf = {
      BIN: `/v1/crm/property_ads/${property.id}/pdf/`,
      DEFAULT: `/v1/properties/${property.id}/pdf/`,
      VIP: `/v1/public/properties/${property.id}/pdf/`,
      REPORT: `/v1/properties/${property}/pdf_report/`
    }
    return type ? typesPdf[type] : typesPdf['DEFAULT']
  }
  function getNamePdf(property) {
    return `${PROPERTY_TYPE_LABELS[property.propertyType]} en ${
      OPERATION_TYPE_LABELS[property.operationType]
    } en ${property.street}, ${property.neighborhood}.pdf`
  }

  const getPdf = (type, property) =>
    dispatch(
      PdfActionCreators.getPdfRequest(
        getEndPoint(type, property),
        getNamePdf(property),
        state.extraInfo
      )
    )

  return (
    <div onClick={() => getPdf(type, property)}>
      {loading && (
        <div className="loadindPdf">
          <Spinner size={15} thickness={5} style={{ margin: '5px' }} />
          Descargando
        </div>
      )}
      {!loading && props.children}
      <style jsx>{styles}</style>
    </div>
  )
}

export default Brochure

Brochure.propTypes = {
  property: PropTypes.object,
  withBrokerInfo: PropTypes.bool,
  withFullAddress: PropTypes.bool,
  type: PropTypes.oneOf(['BIN', 'DEFAULT', 'VIP', 'REPORT'])
}
